//@flow
import React, { useState, useEffect, useRef } from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';

import { logError } from '../../helpers';
import { getEnvironment } from '../../relayModernEnvironment';

import { ProfileFollowButton } from './ProfileFollowButton';

type Props = {
    firmUrlLabel: ?string,
};

type ProfileFollowOutputComponentProps = {
    error?: ?Error,
    props?: ?Object,
};

export function ProfileFollowRenderer(props: Props) {
    const hasMountedRef = useRef(false);
    const [userId, setUserId] = useState('');
    useEffect(() => {
        hasMountedRef.current = true;
        setUserId(getBuyerId(document.cookie));
    }, []);

    const onLogin = newUserId => setUserId(newUserId);

    if (!hasMountedRef.current) {
        return null;
    }

    if (!props.firmUrlLabel) {
        logError('No firm URL label present for follow renderer');
        return null;
    }

    return (
        <QueryRenderer
            environment={getEnvironment()}
            variables={{
                firmUrlLabel: props.firmUrlLabel,
                userId: userId || '',
                hasUserId: !!userId,
            }}
            query={graphql`
                query ProfileFollowRendererQuery(
                    $firmUrlLabel: String!
                    $userId: String!
                    $hasUserId: Boolean!
                ) {
                    viewer {
                        ...ProfileFollowButton_viewer
                    }
                }
            `}
            render={
                /* istanbul ignore next */ (input: ProfileFollowOutputComponentProps) => {
                    if (input.error) {
                        logError(input.error);
                        return null;
                    }

                    const viewer = input.props && input.props.viewer;
                    return (
                        <ProfileFollowButton viewer={viewer} userId={userId} onLogin={onLogin} />
                    );
                }
            }
        />
    );
}
